// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".allowed-groups-settings-content[data-v-1fb1dc4a]{display:flex;align-items:center}.allowed-groups-settings-content .allowed-groups-select[data-v-1fb1dc4a]{width:300px}.allowed-groups-settings-content button[data-v-1fb1dc4a]{margin-left:10px}.multiselect[data-v-1fb1dc4a]{flex-grow:1;max-width:300px}\n", ""]);
// Exports
module.exports = exports;
